import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    display: "flex",
    alignItems: "center",
    "& .MuiPaper-root": {
      backgroundColor: theme.palette.background.main,
    },
  },
  appBar: {
    backgroundColor: theme.palette.background.main,
  },
  changeTheme: {
    marginTop: "4px",
    fontSize: "20px",
    cursor: "pointer",
    "& i": {
      color: theme.palette.secondary.main,
    },
  },
  grow: {
    flexGrow: 1,
    height: "100%",
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  toolbar: {
    height: "100%",
    padding: "0 !important",
  },
  headerMainMenuButton: {
    height: "100%",
    margin: theme.spacing(0, 4),
    display: "flex",
    alignItems: "center",
    textDecoration: "none",
    "&.showActive.active": {},
    "& img": {
      marginRight: theme.spacing(4),
      height: theme.spacing(7),
    },
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
  },
  sectionDesktop: {
    width: "224px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginLeft: theme.spacing(0),
  },
  leftSection: {
    // width: "15%",
  },
  question: {
    borderRadius: "8px",
    marginLeft: "20px",
    border: `1px solid ${theme.palette.secondary.main}`,
    width: "24px",
    height: "24px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    backgroundColor: theme.palette.secondary.main,
    "& i": {
      color: theme.palette.white.main,
    },
  },
  icon: {
    margin: theme.spacing(0, 2),
  },
  icon2: {
    fontSize: theme.fontSize["20"],
    color: theme.palette.secondary.main,
    margin: "8px 6px 8px 0px",
  },
  popOver: {
    // minHeight: theme.spacing(175),
    minWidth: theme.spacing(185),
    borderRadius: theme.spacing(8),
    direction: "ltr",
    overflow: "hidden",
  },
  popOverContainer: {
    borderRadius: theme.spacing(8),
    marginTop: theme.spacing(10),
    marginRight: -theme.spacing(50),
  },
  iconButton: {
    display: "flex",
    alignItems: "center",
    margin: "24px 36px 24px 0px !important",
    padding: "0px !important",
    "&:hover": {
      backgroundColor: "inherit",
      "& .MuiTypography-root": {
        fontFamily: "iranyekanBold !important",
      },
    },
  },
  pageContentWrapper: {
    margin: 0,
    padding: [theme.spacing(0, 26), "!important"],

    "&.classOpanMenu": {
      padding: [theme.spacing(0, 26, 0, 12), "!important"],
    },
    [theme.breakpoints.up("xl")]: {
      padding: [theme.spacing(0, 100), "!important"],
      "&.classOpanMenu": {
        padding: [theme.spacing(0, 100), "!important"],
      },
      "&.opanMenu": {
        padding: [theme.spacing(0, 100), "!important"],
      },
    },
    "&.paddingLayout": {
      padding: [theme.spacing(6, 26), "!important"],
      "&.opanMenu": {
        padding: [theme.spacing(6, 26, 6, 12), "!important"],
      },
    },
  },
  marketStyle: {
    display: "flex",
    alignItems: "center",
    margin: "24px 36px 24px 0px !important",
    padding: "0px !important",
    "&:focus": {
      backgroundColor: theme.palette.background.main,
      color: theme.palette.secondary.main,
      fontWeight: "bold",
      "&:hover": {
        backgroundColor: theme.palette.background.main,
        color: theme.palette.secondary.main,
        boxShadow: "none !important",
      },
      "&:after": {
        color: theme.palette.secondary.main,
        position: "absolute",
        content: "''",
        width: "20%",
        display: "block",
        bottom: 0,
        height: "4px",
        borderRadius: "2px",
        backgroundColor: theme.palette.primary.main,
      },
    },
  },
  marketStyle2: {
    backgroundColor: theme.palette.background.main,
    color: theme.palette.secondary.main,
    display: "flex",
    alignItems: "center",
    margin: "24px 36px 24px 0px !important",
    padding: "0px !important",
    fontWeight: "bold",
    "&:after": {
      position: "absolute",
      content: "''",
      width: "20%",
      display: "block",
      bottom: 0,
      height: "4px",
      borderRadius: "2px",
      backgroundColor: theme.palette.primary.main,
    },
  },
}));
